<template>
  <div>
    <div class="container-fluid container-froDesk">
      <div class="wrapper">
        <div class="content-page content-froDesk">
          <div class="content">
            <div class="row">
              <!-- 课题通知 -->
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <div class="dropdown float-right">
                      <Breadcrumb :id='query.id' :active="2"></Breadcrumb>
                    </div>
                    <h3 class="header-title froDeskHeader-tit mb-3 pb-2">
                      <span class="tit">{{title}}</span>
                      <!-- <span class="ml-1">{{activeBreadcrumb.titleEn}}</span> -->
                    </h3>
                    <div class="General-lists">
                      <ul class="froDesk-Lists mb-3">
                        <li class="li_1" v-for="item in list" :key="item.id" @click="toDetailPage(item.id)">
                          <i class="mdi mdi-arrow-right"></i>
                          <a>{{item.title}}</a>
                          <span class="time">{{item.createTime?item.createTime.substring(5,10):''}}</span>
                        </li>
                      </ul>
                      <el-pagination :page-size="query.pageSize" layout="prev, pager, next" :total="total" @current-change="handlePageChange"></el-pagination>
                    </div>
                  </div>
                  <!-- end card-body-->
                </div>
                <!-- end card-->
              </div>
              <!-- end 课题通知-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getColumnList } from "@/api/before/home";
import { getArticleTree } from '@/api/after/systemManagement';
import Breadcrumb from "@/views/frontDesk/components/Breadcrumb.vue";
export default {
  name: "projectManagement",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      pageType: 0,
      activeBreadcrumb: {},
			title:'',//当前文章列表是那个栏目下的
      query: {
        id: (+ this.$route.params.type),
        pageNumber: 1,
        pageSize: 15,
        pageSorts: [{ asc: true, column: "" }],
      },
      list: [],
      total: 0,
    };
  },
  created() {
    this.getData();
		this.getArticleTree()
  },
  methods: {
		// 获取栏目列表
		getArticleTree() {
			getArticleTree().then(res => {
				if (res.code == 200) {
					console.log('获取文章栏目列表',res);
					this.columnOptions = res.data;
					let curArticleTypeObj = this.columnOptions.find(item=>{
						return item.id == this.query.id
					})
					if (curArticleTypeObj) {
						this.title = curArticleTypeObj.name
					}else{
						this.$message.error('当前文章列表的类型不存在！')
					}
				} else {
					this.$message.error(res.data);
				}
			});
		},
    getData() {
      getColumnList(this.query).then((res) => {
        if (res.code == 200) {
          this.list = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    toDetailPage(id) {
      this.$router.push("/publicDetails/" + id);
    },
    toPage(url) {
      this.$router.push(url);
    },
    // 分页器
    handlePageChange(val) {
      this.query.pageNumber = val;
      this.getData();
    },
  },
};
</script>
<style>
/* 分页器样式 */
.el-pagination {
  text-align: right;
}
.el-pager li {
  margin: 0 4px;
  padding: 0;
  font-size: 13px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  box-sizing: border-box;
}
.el-pager li.active {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
  border-radius: 50%;
}
.el-pager li.active:hover {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
}
.el-pager li:hover {
  color: #313a46;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
  border-radius: 50%;
}
</style>
<style lang="scss" scoped>
/* 通用列表 */
.General-lists {
  margin: 0 auto;
  max-width: 90%;
}
.General-lists .froDesk-Lists li {
  padding: 10px 0;
  height: auto;
  border-bottom: 1px dashed #e3eaef;
  padding-right: 60px;
}
.General-lists .froDesk-Lists li span {
  top: 10px;
}
.conditionTop + .General-lists {
  max-width: 100%;
}
</style>
